module.exports = __webpack_public_path__ + "img/subject_icon_03.png";